<template>
    <div class="sm:col-span-12">
        <div class="bg-gray-100 p-2 h-8">
            <PolynomialDisplay :polynomial="polynomial" />
        </div>
        <div class="flex flex-col gap-2 mt-5">
            <div class="md:grid md:grid-cols-12 md:gap-6">
                <div class="col-span-12">
                    <FormLabel :value="$t('messages.label')" for="label" />
                    <FormInput
                        id="label"
                        v-model.trim="form.label"
                        name="label"
                        @keypress.enter.prevent
                        :placeholder="$t('messages.label')"
                        type="text"
                        required
                        maxlength="30"
                        class="mt-1 w-full"
                    />
                    <FormError :value="errors[`options.label`]" class="mt-2" />
                </div>
                <div class="col-span-12" v-for="i in [0, 1, 2, 3, 4, 5, 6]" :key="i">
                    <FormLabel :for="`x_${i}`" v-if="i === 0">
                        {{ $t('messages.polynomial_degree_zero_term') }}
                    </FormLabel>
                    <FormLabel :for="`x_${i}`" v-else>
                        {{ form.label || 'x' }} <sup>{{ i }}</sup>
                    </FormLabel>
                    <FormInput
                        :id="`x_${i}`"
                        v-model.trim="form[`x_${i}`]"
                        :name="`x_${i}`"
                        @keypress.enter.prevent
                        type="number"
                        :required="isRequired"
                        step="1"
                        class="mt-1 w-full"
                    />
                    <FormError :value="errors[`options.x_${i}`]" class="mt-2" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormError from '@/components/Forms/FormError.vue';
import PolynomialDisplay from '@/components/Quiz/PolynomialDisplay.vue';

export default {
    name: 'QuestionMathPolynomialOperationOptions',
    components: {
        PolynomialDisplay,
        FormLabel,
        FormInput,
        FormError,
    },
    props: {
        modelValue: {
            required: true,
        },
        errors: {
            required: true,
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            form: this.modelValue,
        };
    },
    watch: {
        form(newVal) {
            this.$emit('update:modelValue', newVal);
        },
    },
    computed: {
        polynomial() {
            return {
                label: this.form.label,
                x_0: this.form.x_0,
                x_1: this.form.x_1,
                x_2: this.form.x_2,
                x_3: this.form.x_3,
                x_4: this.form.x_4,
                x_5: this.form.x_5,
                x_6: this.form.x_6,
            };
        },
        isRequired() {
            const total =
                this.form.x_0 +
                this.form.x_1 +
                this.form.x_2 +
                this.form.x_3 +
                this.form.x_4 +
                this.form.x_5 +
                this.form.x_6;

            return total === 0;
        },
    },
    mounted() {
        let defaultOptions = {
            label: 'x',
            x_0: '',
            x_1: '',
            x_2: '',
            x_3: '',
            x_4: '',
            x_5: '',
            x_6: '',
        };
        if (!this.form.hasOwnProperty('x_0')) {
            Object.entries(defaultOptions).forEach((entry) => (this.form[entry[0]] = entry[1]));
        }
    },
};
</script>
